<style lang="scss" scoped>
  .container {
    .header {
      display: grid;
      // grid-template-columns: repeat(3, 33.3%);
      grid-template-columns: repeat(auto-fill, 500px);
      gap: 8px 40px;
      width: 100%;
      margin-bottom: 20px;

      .info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: nowrap;
        .detail {
          width: 80px;
          // background-color: #ECF5FF;
          .detail-title {
            color: #909399;
            font-size: 12px;
            display: inline-block;
            width: 38px;
            height: 12px;
            line-height: 12px;
          }

          .detail-value {
            color: #303133;
            font-size: 12px;
			margin-left: 5px;
          }
        }
      }
    }
  }
</style>
<template>
  <div class="container">
    <div class="header">
      <div v-for="(item, index) in info" :key="index" class="info">
        <div class="details" style="width:145px;">
          <span>{{ getCNNum(index) }}:</span>
        </div>
        <div class="detail">
          <span class="detail-title">{{$t('yangbenshu')}}</span>
          <span class="detail-value">{{item.sampleValue}}</span>
        </div>
        <div class="detail">
          <span class="detail-title">{{$t('zuidazhi')}}</span>
          <span class="detail-value">{{item.maxValue}}</span>
        </div>
        <div class="detail">
          <span class="detail-title">{{$t('zuixiaozhi')}}</span>
          <span class="detail-value">{{item.minValue}}</span>
        </div>
        <div class="detail">
          <span class="detail-title">{{$t('zhongweishu')}}</span>
          <span class="detail-value">{{item.middleValue}}</span>
        </div>
      </div>
    </div>
    <div id="myChart" style="width: 100%;height: 400px;margin-left: -25px;"></div>

    <div id="workshopEquipmentTabStatusChart" :style="{'height':chartHeight2+'px'}" style="width: 100%;margin-top: 2px;margin-left: -5px"></div>
  </div>
</template>

<script>
  export default {
    name: 'single_chart',
    filters: {
      getCNNameByCode(code, that) {
        let res = that.dict.filter(item => {
          return item.code === code
        })
        if (res.length > 0) {
          const unit = res[0]['unit'];
          return unit ? res[0]['i18n'] + '(' + unit + ')' : res[0]['i18n'];
        } else {
          return code
        }
      }
    },
    props: {
      list: {
        type: Array,
        default: () => {
          return []
        }
      },
      codes: {
        type: Array,
        default: () => {
          return []
        }
      },
      dict: {
        type: Array,
        default: () => {
          return []
        }
      },
      conditions: []
    },
    data() {
      return {
        screenWidth: '', // 可视窗口的宽度
        that: this,
        chartList: [],
        myChart: null,
        title: '',
        info: [],
        // 设备状态条
        chart2: null,
        options2: null,
        chartHeight2: 100,
        chart2ValueData: [],
        statusColors: {
          "0": "#7DFFBE",
          "3": "#FF809F",
          "1": "#FFD580",
          "-1": "#7582A3",
          "-2": "#7582A3",
        }
      }
    },

    watch: {
      list: {
        handler(n) {
          this.fetchChart()
          this.getEquipmentShitState()
          if (this.chart2) {
            this.chart2.resize()
          }
        },
        immediate: false,
        deep: true
      }
    },
    mounted() {
      this.resize()
      this.utils.event_hub.$on('RESIZE', () => {
        this.resize();

      });
      this.fetchChart()
      this.getEquipmentShitState()
    },
    activated() {
      this.resize()
    },
    methods: {
      getCNNum(index) {
        const obj = this.title
        console.log('obj', obj)
        return obj[index + 1]
      },
      // 工艺参数中文映射
      getCNNameByCode(code) {
        let res = this.dict.filter(item => {
          return item.code === code
        });
        if (res.length > 0) {
          const unit = res[0]['unit'];
          return unit ? res[0]['i18n'] + '(' + unit + ')' : res[0]['i18n'];
        } else {
			
          return code
        }
      },
      /**
       * 时间转换
       * @param time
       * @returns {string}
       */
      timestampToTime(time) {
        const t = new Date(time)
        // 日期格式
        const format = 'Y-m-d h:i:s'
        let year = t.getFullYear()
        // 由于 getMonth 返回值会比正常月份小 1
        let month = t.getMonth() + 1
        let day = t.getDate() + '\n'
        let hours = t.getHours()
        let minutes = t.getMinutes()
        let seconds = t.getSeconds()
        month = month > 9 ? month : `0${month}`
        day = day > 9 ? day : `0${day}`
        hours = hours > 9 ? hours : `0${hours}`
        minutes = minutes > 9 ? minutes : `0${minutes}`
        seconds = seconds > 9 ? seconds : `0${seconds}`
        const hash = {
          'Y': year,
          'm': month,
          'd': day,
          'h': hours,
          'i': minutes,
          's': seconds
        }
        return format.replace(/\w/g, o => {
          return hash[o]
        })
      },
      /**
       * 重置图表
       */
      resize() {
        //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
        setTimeout(() => {
          // this.screenWidth = document.body.clientWidth
          this.screenWidth = document.body.clientWidth
          if (this.myChart != null) {
              console.log('vvvvvv',this.myChart)
            this.myChart.resize()
          }
          if (this.chart2) {
            this.chart2.resize()
          }
          if (this.chartList.length > 0) {
            for (let i = 0; i < this.chartList.length; i++) {
              if (this.chartList[i]['barChart'] != null) {
                this.chartList[i]['barChart'].resize()
              }
            }
          }
        }, 500)
      },
      /**
       * 渲染图表
       * @returns {boolean}
       */
      fetchChart() {
        this.myChart = this.echarts.init(document.getElementById(('myChart')))
        // if (this.myChart !== null) {
        //   myChart.resize()
        // }
        this.chartList = []
        this.title = ''
        this.info = []
        if (this.list.length === 0) {
          return false
        }
        const pointCodes = [...this.codes]
        if (pointCodes.length === 0) {
          return false
        }
        for (let i = 0; i < pointCodes.length; i++) {
          this.chartList.push({
            id: 'id' + i, // 索引
            barChart: '', // chart对象实例
            maxValue: 0, // 最大数
            minValue: 0, // 最小数
            middleValue: 0, // 中位数
            sampleValue: 0, // 样本数
            echartData: [], // 图表数据
            pointCodes: pointCodes[i]
          })
        }
        const arr = [...this.list]
        for (let i = 0; i < arr.length; i++) {
          for (let j = 0; j < arr[i]['points'].length; j++) {
            for (let z = 0; z < this.chartList.length; z++) {
              if (this.chartList[z]['pointCodes'] === arr[i]['points'][j]['code']) {
                this.chartList[z]['echartData'].push({
                  ...arr[i]['points'][j],
                  time: arr[i]['time']
                })
              }
            }
          }
        }
        const xAxis = arr.map(item => {
          return this.timestampToTime(item.time)
        })
        this.$nextTick(() => {
          const series = []
          const titleList = []
          for (let i = 0; i < this.chartList.length; i++) {
            series.push({
              name: this.getCNNameByCode(this.chartList[i]['pointCodes']),
              smooth: true,
              type: 'line',
              data: this.chartList[i]['echartData'].map(item => {
                return item.value
              }),
              showSymbol: false,
            })
            titleList.push(this.getCNNameByCode(this.chartList[i]['pointCodes']))
            this.info.push({
              sampleValue: this.chartList[i]['echartData'].length,
              maxValue: Math.max.apply(Math, this.chartList[i]['echartData'].map(o => {
                return o.value
              })), // 最大值
              minValue: Math.min.apply(Math, this.chartList[i]['echartData'].map(o => {
                return o.value
              })), // 最小值
              middleValue: ((Math.max.apply(Math, this.chartList[i]['echartData'].map(o => {
                return o.value
              })) + Math.min.apply(Math, this.chartList[i]['echartData'].map(
                o => {
                  return o.value
                }))) / 2).toFixed(1)
            })
          }
          // this.title = titleList.join('/')
          this.title = Object.assign({}, titleList)
          const temp = {}
          const arr = Object.values(this.title)
          let num = 1
          for (let i = 0; i < arr.length; i++) {
            temp[num] = arr[i]
            num++
          }
          this.title = temp
          let option = {
            tooltip: {
              trigger: 'axis',
			  formatter: (params) => {			
			    const result = []
			    const title = params[0]['name']
			    for (let i = 0; i < params.length; i++) {
			      const unit = params[i]['seriesName']
				  // const regex = /\((.+?)\)/g;unit.match(regex)
			      result.push(params[i]['marker'] + '  ' + params[i]['seriesName'] +
			        ' ' + params[i]['value'] + unit.substring(unit.indexOf('(') + 1, unit.indexOf(')'))) 		
			    }
			    return title + '<br />' + '<br />' + result.join('<br />')
			  },		  
            },
            legend: {
              show: true,
              icon: "roundRect", //形状  类型包括 circle，rect,line，roundRect，triangle，diamond，pin，arrow，none
              itemWidth: 12, // 设置宽度
              itemHeight: 2, // 设置高度
              itemGap: 16, // 设置间距
              x: 'center',
            },
            grid: {
              top: '40',
              left: '20',
              right: '-30',
              bottom: '20',
              containLabel: true
            },
            toolbox: {
              show: true,
              feature: {}
            },
            calculable: true,
            xAxis: [{
              type: 'category',
              boundaryGap: true,
              data: xAxis,
              axisTick: {
                alignWithLabel: true,
              },
            }],
            yAxis: {
              type: 'value',
              axisLine: {
                show: false
              },
              axisTick: {
                show: true
              }
            },
            series: series
          }
          this.myChart.setOption(option)
        });
      },

      async getEquipmentShitState() {
        this.chart2 = null;
        // 获取当前时间的时间戳
        const currentTime = Date.now();
        // 获取条件中的 endTime 时间戳
        const endTime = this.conditions["endTime"];

        // 判断 endTime 是否大于当前时间，如果大于，则使用当前时间，否则使用 endTime
        const adjustedEndTime = endTime > currentTime ? currentTime : endTime;

        // 发起请求，使用 adjustedEndTime 作为结束时间
        let response = await this.http.get('/web/equipment/getEquipmentShitState/history', {
          params: {
            equipmentId: this.conditions["equipmentIds"],
            startTime: this.conditions["startTime"],
            endTime: adjustedEndTime
          }
        });
        let xWidth = (adjustedEndTime - this.conditions["startTime"]) / 24/1000
        //总时长
        this.chart2ValueData = response.data.map(item => {
          item.last = ((this.dayjs(item.et).unix() - this.dayjs(item.st).unix()) / xWidth)

          return {
            s: item.s,
            st: item.st,
            et: item.et,
            name: '',
            type: 'bar',
            stack: 'total',
            label: {
              show: false
            },
            emphasis: {
              focus: 'series'
            },
            itemStyle: {
              normal: {
                color: this.statusColors[item.s],
                barBorderRadius: 0,
              },
            },
            data: [item.last]
          }

        })

        if (!this.chart2) {
          setTimeout(() => {
            this.initChart2()
          }, 100)
        } else {

          //班制变更，那么就是新的比旧的少，需要重新创建
          if (this.chart2ValueData.length < this.options2.series) {
            this.chart2.dispose();
            this.chart2 = null
            this.initChart2()

          }
          this.option2.series = this.chart2ValueData;
          this.chart2.setOption(this.option2)


        }

      },

      initChart2() {
        console.log( this.chart2ValueData)
        this.option2 = {
          tooltip: {
            show: false,
            trigger: 'axis',
            axisPointer: {
              // Use axis to trigger tooltip
              type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
            }
          },
          legend: {
            show: false,
          },
          grid: {
            top: '10',
            left: '0',
            right: '10',
            bottom: '30',
            containLabel: true
          },
          xAxis: {
            type: 'value',
            boundaryGap: false,
            min:0,
            max:24,
            minInterval: 1,
            maxInterval: 1,
            axisLabel: {
              show: false,
              formatter: (value, index) => {
                if (this.chart2ValueData) {
                  return index.toString();
                }
                return "-"
              }

            }
          },
          yAxis: {
            show: false,
            type: 'category',
          },
          series: this.chart2ValueData
        };
        var chartDom = document.getElementById('workshopEquipmentTabStatusChart');
        this.chart2 = this.echarts.init(chartDom);
        this.option2 && this.chart2.setOption(this.option2);
      },


    }
  }
</script>
